import api from 'services/api';

import { HttpCodes } from 'v2/resources/types/httpCode';
import {
  IParamsChoosePropertie,
  IPropertie,
  IResponseChoosePropertie,
} from 'v2/resources/types/properties';
import {
  DEFAULT_RESPONSE_CHOSEN_PROPERTIE,
  DEFAULT_RESPONSE_PROPORTIES,
} from './types';

export const PropertiesServices = {
  getProperties: async (): Promise<IPropertie[]> => {
    const response = await api.get<IPropertie[]>('/properties');

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }

    return DEFAULT_RESPONSE_PROPORTIES;
  },
  chooseProperties: async ({
    id,
    name,
  }: IParamsChoosePropertie): Promise<IResponseChoosePropertie> => {
    const response = await api.get<IResponseChoosePropertie>(
      `/properties/choose/${id}`
    );

    if (response.status === HttpCodes.SUCCESS) {
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('idProperty', String(id));
      localStorage.setItem('nameProperty', name);
      return response.data;
    }

    return DEFAULT_RESPONSE_CHOSEN_PROPERTIE;
  },
};
